<template lang="pug">
.activity-reply
  .row
    .col
      .activity-avatar
        UserAvatar(:user="reply.user")
    .col.max
      .activity-header
        .row.apart
          .col
            span.creator {{ reply.user.fullName }} replied...
          .col
            span.created {{ reply.created | moment("from") }}
      .activity-body(v-html="commentFormatted")


      .activity-attachments(v-if="reply.attachments")
        a.activity-attachment(v-for="attachment in reply.attachments", @click.stop, :href="attachment.url", target="_blank")
          img(:src="attachment.url")
            

</template>

<script>

import CommentForm from '@/components/CommentForm'

const urlRegex = /(https?:\/\/[^\s]+)/g

export default {
  name: 'CommentReply',
  components: {
    CommentForm
  },
  props: {
    reply: Object
  },
  data () {
    return {
    }
  },
  computed: {
    commentFormatted () {
      let comment = ''
      if (this.reply.comment) {
        comment = this.reply.comment.replace(/\n/g, '<br/>')
        comment = comment.replace(urlRegex, '<a target="_blank" href="$1">$1</a>')
      }
      return comment
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
  .activity-comment
    border-bottom $border-default
    display block
    margin-bottom $spacing
    padding $spacing-2 0

    .activity-header
      color $text-light

    .creator
      font-size $text-size-small
      line-height $text-size-default
    .created
      font-size $text-size-smaller
      line-height $text-size-default


    .activity-body
      color $text-light
      line-height 22px
      margin-bottom $spacing
      padding $spacing-2 0
      a
        &:hover
          text-decoration underline
    .activity-attachments
      margin-bottom $spacing
    .activity-attachment
      border $border-default
      border-radius $border-radius
      display inline-block
      padding 2px
      vertical-align top
      img
        max-width 100px
    .footer
      font-size $text-size-small
      color $text-light
      
      span
        display inline-block
        margin-right $spacing
    .reply-to
      padding-top $spacing-2
    .activity-replies
      padding-top $spacing-3
      //padding-left $spacing-2
  
  .activity-avatar
    width 50px
</style>
